<template>
  <div
    class="next-button"
    :class="[
      { 'next-button--disabled': disabled },
    ]"  
  >
    <button
      class="next-button__button"
      @click="handleClick"
      :disabled="disabled"
    >
      <slot></slot>
    </button>
  </div>
</template>

<script setup lang="ts">
import pinia from '../../core/pinia';
import { useLineItemStore, useStepsStore } from '../../stores';
import { E_NEXT_BUTTON_EVENT } from '../../types/components-events.enums';
import type { TNextButtonEventResponse } from '../../types/event-response.types';

interface IProps {
  disabled?: boolean;
  useCustomEvent?: boolean;
}
const props = defineProps<IProps>();
const emit = defineEmits<{
  (e: E_NEXT_BUTTON_EVENT.CLICK, payload: TNextButtonEventResponse[E_NEXT_BUTTON_EVENT.CLICK]): TNextButtonEventResponse;
  (e: E_NEXT_BUTTON_EVENT.CUSTOM_EVENT, payload: TNextButtonEventResponse[E_NEXT_BUTTON_EVENT.CUSTOM_EVENT]): TNextButtonEventResponse;
}>();

const stepsStore = useStepsStore(pinia);
const lineItemStore = useLineItemStore(pinia);

function defaultHandle() {
  stepsStore.nextStep();
}

function handleClick() {
  if (!props.useCustomEvent) {
    defaultHandle();
  }
  emit(E_NEXT_BUTTON_EVENT.CLICK);
  if (props.useCustomEvent) {
    emit(
      E_NEXT_BUTTON_EVENT.CUSTOM_EVENT,
      lineItemStore.getLineItem
    );
  }
}
</script>

<style scoped lang="scss">
.next-button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  &__button {
    font-family: 'Bebas Neue', sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 16px;
    letter-spacing: 0.5px;
    text-align: center;
    vertical-align: middle;
    color: #78858C;
    text-transform: uppercase;
    width: 100%;
    padding: 12px 14px;
    border: 1px solid #78858C;
    background: none;
    cursor: pointer;

    &:disabled {
      background: #E6E6E6;
      color: #B2B2B2;
      cursor: default;
    }
  }
}
</style>